export function getLiterAmount(value: number) {
  if (!!!value) {
    return '-'
  }
  return Math.trunc(Number(value) * 100) / 100
}
